import { routing } from '@utils/routing';
import { reverse } from 'named-urls';
export const createGetReportTo = (location) => (reportType) => {
    return {
        pathname: reverse(routing.analytics.overview.report.self, { reportType }),
        search: location.search,
    };
};
